import PartnerToken from './PartnerTokenDef';

export default {
  PartnerToken,
};
